import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import InternalCorrectionMaintenanceCont from "presentation/view/container/InternalCorrection/InternalCorrectionContMain";

CommonEntrypoint(<InternalCorrectionMaintenanceCont/>)